import api from './apiService';
export async function enableEmergencyPush() {
  const key = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY;
  if (!key) throw new Error('Browser push has not been configured for this installation');
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) throw new Error('Background notifications are unavailable in this browser');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission was not granted');
  const registration = await navigator.serviceWorker.register('/emergency-sw.js');
  await navigator.serviceWorker.ready;
  const raw = atob(key.replace(/-/g, '+').replace(/_/g, '/'));
  const applicationServerKey = Uint8Array.from(raw, c => c.charCodeAt(0));
  const subscription = await registration.pushManager.getSubscription() || await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  await api.post('/devices/register', { platform: 'web', push_token: 'web-pending', web_subscription: JSON.stringify(subscription.toJSON()) });
}
export async function disableEmergencyPush() {
  if (!('serviceWorker' in navigator)) return;
  const registration = await navigator.serviceWorker.getRegistration('/emergency-sw.js');
  const subscription = await registration?.pushManager.getSubscription();
  await subscription?.unsubscribe();
}
